<div class="w-full max-w-full">
  <div class="custom-scrollbar h-full w-full rounded-lg border-2 border-black bg-white">
    <div class="overflow-x-auto rounded-lg bg-white p-3">
      <div
        class="grid min-w-[1000px] grid-rows-[repeat(7,minmax(0,1fr))]"
        [ngStyle]="{ 'grid-template-columns': 'repeat(' + columnCount + ', minmax(0, 1fr))' }"
      >
        <div *ngFor="let row of rows; let rowIndex = index" class="contents">
          <div
            *ngFor="let cell of [].constructor(columnCount); let cellIndex = index"
            class="flex h-[17px] items-center justify-center border-b-2 border-r-2 border-black md:h-8 lg:h-10"
            [ngClass]="{
              'border-l-2': cellIndex === 0,
              'border-t-2': rowIndex === 0
            }"
          >
            <div *ngIf="colors[rowIndex][cellIndex]" class="flex items-center justify-center">
              <div
                class="h-2.5 w-2 rounded-full md:h-4 md:w-4 lg:h-6 lg:w-6 xl:h-6 xl:w-6"
                [ngStyle]="{ 'background-color': colors[rowIndex][cellIndex] }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
